import React, { useState } from 'react';
import { Toaster } from 'sonner';
import HRPortalLayout from './components/HRPortalLayout';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import Documents from './pages/Documents';
import Reports from './pages/Reports';
import Onboarding from './pages/Onboarding';
import Attendance from './pages/Attendance';
import LeaveManagement from './pages/LeaveManagement';
import Offboarding from './pages/Offboarding';
import type { HRPortalPage } from './types/hrPortalTypes';
import ShadowWrapper from 'ShadowWrapper';

interface HRPortalAppProps {
  asPortal?: boolean;
}

const HRPortalApp: React.FC<HRPortalAppProps> = ({ asPortal = false }) => {
  const [currentPage, setCurrentPage] = useState<HRPortalPage>('dashboard');

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard />;
      case 'employees':
        return <Employees />;
      case 'documents':
        return <Documents />;
      case 'reports':
        return <Reports />;
      case 'onboarding':
        return <Onboarding />;
      case 'attendance':
        return <Attendance />;
      case 'leave-management':
        return <LeaveManagement />;
      case 'offboarding':
        return <Offboarding />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <>

        <Toaster position="top-right" richColors />
        <HRPortalLayout
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          asPortal={asPortal}
        >
          {renderPage()}
        </HRPortalLayout>
    </>
  );
};

export default HRPortalApp;
